if (!customElements.get('skinmedicine-header')) {
  class SkinmedicineHeader extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.header-skinmedicine__mobile-menu');
      this.menu = this.querySelector('.header-skinmedicine__mobile-nav');
      this.closeButtons = this.querySelectorAll('[data-menu-close]');
      if (!this.toggle || !this.menu) return;

      this.handleKeydown = this.handleKeydown.bind(this);
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);

      this.toggle.addEventListener('click', this.open);
      this.closeButtons.forEach((button) => button.addEventListener('click', this.close));
      this.querySelectorAll('.header-skinmedicine__mobile-nav-link, .header-skinmedicine__mobile-account-link')
        .forEach((link) => link.addEventListener('click', this.close));
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleKeydown);
      document.body.classList.remove('skinmedicine-menu-open');
    }

    open() {
      this.menu.removeAttribute('inert');
      this.menu.setAttribute('aria-hidden', 'false');
      this.menu.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('skinmedicine-menu-open');
      document.addEventListener('keydown', this.handleKeydown);
      window.setTimeout(() => {
        this.menu.querySelector('.header-skinmedicine__mobile-close')?.focus({ preventScroll: true });
      }, 120);
    }

    close() {
      if (!this.menu.classList.contains('is-open')) return;
      this.menu.classList.remove('is-open');
      this.menu.setAttribute('aria-hidden', 'true');
      this.menu.setAttribute('inert', '');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('skinmedicine-menu-open');
      document.removeEventListener('keydown', this.handleKeydown);
      this.toggle.focus();
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = [...this.menu.querySelectorAll('a[href], button:not([disabled])')]
        .filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('skinmedicine-header', SkinmedicineHeader);
}
